export const LastUpdated = '21 Décembre 2025';
